import { render, staticRenderFns } from "./top-10-sparepart.vue?vue&type=template&id=5987a306&scoped=true&"
import script from "./top-10-sparepart.vue?vue&type=script&lang=js&"
export * from "./top-10-sparepart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5987a306",
  null
  
)

export default component.exports